import { useBucket } from '@mc/experiments-react'
import { useStaticData } from '@mc/static-data-react'
import { useGiftEnabled } from '../../../lib/helpers/useGiftEnabled'
import { PROMO_BANNER_GIFT_CTA_FLAG_NAME } from '../constants'

// Mirrors trackPen7680BackendEV in apps/next — both gates have to stay in step.
// Only called from the mounted banner, so an active promotion is implied.
export const useExperiment = ({ hideCta = false }: { hideCta?: boolean }) => {
  const { giftEnabled } = useGiftEnabled()
  const { isLoggedIn } = useStaticData<{ isLoggedIn?: boolean }>()
  const bucket = useBucket(PROMO_BANNER_GIFT_CTA_FLAG_NAME)

  const isEligible = giftEnabled && !isLoggedIn && !hideCta

  return {
    isEligible,
    isVariant: isEligible && bucket === 'variant_1',
  }
}
